import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut } from "lucide-react";
import { getInitials } from "../utils/formatters";
import MuiPopper from "./ui/MuiPopper";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { useTheme } from "../context/ThemeContext";

import {
    HelpCircle,
    UserCircle,
    Sparkles,
    Contrast,
    FileText,
} from "lucide-react";
import ContentCard from "./ui/ContentCard";
const MyAccount = ({ collapsed }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const handleLogout = () => {
        logout();
    };

    const [showThemeList, setShowThemeList] = useState(false);
    const { updateTheme } = useTheme();
    const themes = [{ theme: "Light" }, { theme: "Dark" }, { theme: "System" }];

    function RenderThemeList({ handleClose }) {
        const themeList = themes.map((thememode) => {
            return (
                <button
                    onClick={async () => {
                        await updateTheme(thememode.theme.toUpperCase());
                        setShowThemeList(false);
                        handleClose();
                    }}
                    className="flex flex-row ml-8 items-center"
                >
                    <ContentCard
                        variant={thememode.theme === "Light" ? "light" : "dark"}
                        className={"basis-1/3 mr-4"}
                    ></ContentCard>
                    <p className={"text-center"}>{thememode.theme}</p>
                </button>
            );
        });
        return themeList;
    }

    return (
        <MuiPopper
            style={{ marginLeft: "-5px" }}
            Icon={
                <>
                    <Avatar
                        className="w-8 h-8"
                        key={user?.profile_image || "no-image"}
                    >
                        {user?.profile_image &&
                            user.profile_image !== null &&
                            user.profile_image !== undefined &&
                            user.profile_image.trim() !== "" ? (
                            <AvatarImage
                                src={user.profile_image}
                                alt={user?.full_name || user?.email}
                                onError={(e) => {
                                    e.target.style.display = "none";
                                }}
                            />
                        ) : null}
                        <AvatarFallback className="bg-primary-600 text-white text-xs font-semibold">
                            {getInitials(user?.full_name || user?.email || "U")}
                        </AvatarFallback>
                    </Avatar>
                    {!collapsed && <Typography sx={{ marginLeft: "4px" }}>{(user?.full_name || user?.email)?.slice(0, 15)}...</Typography>}
                </>
            }
        >
            {({ handleClose }) => {
                return (
                    <>
                        <div
                            style={{
                                gap: "4px",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <div
                                style={{
                                    alignItems: "center",
                                    display: "flex",
                                    gap: "8px",
                                    flexDirection: "column",
                                }}
                            >
                                <div
                                    style={{
                                        alignItems: "center",
                                        display: "flex",
                                        gap: "8px",
                                        padding: "6px 10px",
                                    }}
                                >
                                    <Avatar
                                        className="w-12 h-12"
                                        key={user?.profile_image || "no-image"}
                                    >
                                        {user?.profile_image &&
                                            user.profile_image !== null &&
                                            user.profile_image !== undefined &&
                                            user.profile_image.trim() !== "" ? (
                                            <AvatarImage
                                                src={user.profile_image}
                                                alt={user?.full_name || user?.email}
                                                onError={(e) => {
                                                    e.target.style.display = "none";
                                                }}
                                            />
                                        ) : null}
                                        <AvatarFallback className="bg-primary-600 text-white text-xs font-semibold">
                                            {getInitials(
                                                user?.full_name || user?.email || "U",
                                            )}
                                        </AvatarFallback>
                                    </Avatar>
                                    <div>
                                        <Typography fontWeight={500}>
                                            {user?.full_name}
                                        </Typography>

                                        <Typography
                                            fontWeight={400}
                                            color="rgb(107, 114, 128)"
                                        >
                                            {user?.email}
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                            <Divider sx={{ borderBottomWidth: "2px" }} />

                            <button
                                onClick={() => {
                                    sessionStorage.setItem(
                                        "myAccountFrom",
                                        location.pathname + location.search,
                                    );
                                    navigate("/my-account");
                                    handleClose();
                                }}
                                className="flex items-center space-x-2 text-text-secondary hover:text-text-primary transition-colors p-2 rounded-md hover:bg-bg-hover"
                            >
                                <UserCircle className="w-4 h-4" />
                                <span className="hidden sm:inline">My Profile</span>
                            </button>

                            <Divider sx={{ borderBottomWidth: "2px" }} />

                            <button
                                onClick={() => {
                                    setShowThemeList((prev) => !prev);
                                }}
                                className="flex items-center space-x-2 text-text-secondary hover:text-text-primary transition-colors p-2 rounded-md hover:bg-bg-hover"
                            >
                                <Contrast className="w-4 h-4" />
                                <span className="hidden sm:inline">Theme</span>
                            </button>

                            {showThemeList ? (
                                <div className="flex flex-col gap-4 text-<20px>/[<31px>] font-medium my-1">
                                    <RenderThemeList handleClose={handleClose} />
                                </div>
                            ) : (
                                <></>
                            )}

                            <Divider sx={{ borderBottomWidth: "2px" }} />
                            <button
                                onClick={() => {
                                    navigate("/documentation");
                                    handleClose();
                                }}
                                className="flex items-center space-x-2 text-text-secondary hover:text-text-primary transition-colors p-2 rounded-md hover:bg-bg-hover"
                            >
                                <FileText className="w-4 h-4" />
                                <span className="hidden sm:inline">Documentations</span>
                            </button>
                            <Divider sx={{ borderBottomWidth: "2px" }} />
                            <button
                                onClick={() => {
                                    navigate("/support");
                                    handleClose();
                                }}
                                className="flex items-center space-x-2 text-text-secondary hover:text-text-primary transition-colors p-2 rounded-md hover:bg-bg-hover"
                            >
                                <HelpCircle className="w-4 h-4" />
                                <span className="hidden sm:inline">Help Center</span>
                            </button>
                            {<Divider sx={{ borderBottomWidth: "2px" }} />}

                            <button
                                onClick={() => {
                                    // window.location.href = "/#pricing-plans";
                                    handleClose();
                                }}
                                className="flex items-center space-x-2 text-text-secondary hover:text-text-primary transition-colors p-2 rounded-md hover:bg-bg-hover"
                            >
                                <Sparkles className="w-4 h-4 text-red-500" />
                                <span className="hidden md:inline sm:inline">
                                    Upgrade Plan
                                </span>
                            </button>

                            <button
                                onClick={() => {
                                    handleClose();
                                    handleLogout();
                                }}
                                className="flex items-center space-x-2 text-text-secondary hover:text-text-primary transition-colors p-2 rounded-md hover:bg-bg-hover"
                            >
                                <LogOut className="w-4 h-4" />
                                <span className="hidden sm:inline">Sign Out</span>
                            </button>
                        </div>
                    </>
                );
            }}
        </MuiPopper>
    );
};

export default MyAccount;
